module.exports = __webpack_public_path__ + "04_long_brown.bd991cee.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/04_long_brown.png
// module id = FkxW
// module chunks = 0